var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDailySummary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 5.66663C1.33333 4.26649 1.33333 3.56643 1.60582 3.03165C1.8455 2.56124 2.22795 2.17879 2.69836 1.93911C3.23314 1.66663 3.9332 1.66663 5.33333 1.66663H9.66667L14.6667 6.66663V14.3333C14.6667 15.7334 14.6667 16.4335 14.3942 16.9683C14.1545 17.4387 13.772 17.8211 13.3016 18.0608C12.7669 18.3333 12.0668 18.3333 10.6667 18.3333H5.33333C3.9332 18.3333 3.23314 18.3333 2.69836 18.0608C2.22795 17.8211 1.8455 17.4387 1.60582 16.9683C1.33333 16.4335 1.33333 15.7334 1.33333 14.3333V5.66663Z",
    fill: "#F3FDE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 7.49996H4.66667H6.33333Z",
    fill: "#F3FDE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 1.89124V5.33335C9.66667 5.80006 9.66667 6.03342 9.75749 6.21168C9.83739 6.36848 9.96487 6.49596 10.1217 6.57586C10.2999 6.66669 10.5333 6.66669 11 6.66669H14.4421M11.3333 10.8333H4.66667M11.3333 14.1666H4.66667M6.33333 7.49996H4.66667M9.66667 1.66663H5.33333C3.9332 1.66663 3.23314 1.66663 2.69836 1.93911C2.22795 2.17879 1.8455 2.56124 1.60582 3.03165C1.33333 3.56643 1.33333 4.26649 1.33333 5.66663V14.3333C1.33333 15.7334 1.33333 16.4335 1.60582 16.9683C1.8455 17.4387 2.22795 17.8211 2.69836 18.0608C3.23314 18.3333 3.9332 18.3333 5.33333 18.3333H10.6667C12.0668 18.3333 12.7669 18.3333 13.3016 18.0608C13.772 17.8211 14.1545 17.4387 14.3942 16.9683C14.6667 16.4335 14.6667 15.7334 14.6667 14.3333V6.66663L9.66667 1.66663Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailySummary);
export default __webpack_public_path__ + "static/media/daily-summary.e1f5da1c.svg";
export { ForwardRef as ReactComponent };